export default __webpack_public_path__ + "static/banner-2-adec8a473b32cae1ccdc08137bd74fc6.jpg";